import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SERVE } from "../data/content";

export default function ServeSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-36" data-testid="serve-section">
      <Reveal className="max-w-2xl mb-14 md:mb-20">
        <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">
          Built for the people who move real estate.
        </h2>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10 rounded-3xl overflow-hidden">
        {SERVE.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.06}>
            <div className="group bg-white h-full p-8 md:p-10 transition-colors duration-500 hover:bg-[#0a0a0a] hover:text-white" data-testid={`serve-${i}`}>
              <h3 className="font-display text-2xl tracking-tight font-medium">{s.title}</h3>
              <p className="mt-3 text-neutral-500 group-hover:text-neutral-300 leading-relaxed transition-colors">{s.line}</p>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.12}>
          <Link to="/book-demo" className="group bg-white h-full p-8 md:p-10 flex flex-col justify-between transition-colors duration-500 hover:bg-[#0a0a0a] hover:text-white" data-testid="serve-cta">
            <h3 className="font-display text-2xl tracking-tight font-medium">Not sure which fits?</h3>
            <span className="mt-6 inline-flex items-center gap-2 text-neutral-500 group-hover:text-white transition-colors">
              Book a discovery call <ArrowUpRight size={18} />
            </span>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
